__webpack_require__.O(0, ["welcome"], () => {
	__webpack_require__.E("home_async");
}, 5);